import { render } from "./Dot.vue?vue&type=template&id=5b248ecd"
import script from "./Dot.vue?vue&type=script&lang=js"
export * from "./Dot.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__